module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', [(!_vm.isUpdate) ? _c('TextInputBloc', {
    staticClass: "name",
    attrs: {
      "label": 'Forecast Ref',
      "required": true,
      "value": _vm.formForecast.reference,
      "validator": _vm.FORM_VALIDATORS.name,
      "max-length": _vm.textFieldMaxLength
    },
    on: {
      "input": function($event) {
        _vm.formForecast.reference = $event;
        _vm.onInputChange();
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(!_vm.isUpdate) ? _c('TextInputBloc', {
    staticClass: "name",
    attrs: {
      "label": 'Name',
      "required": true,
      "value": _vm.formForecast.name,
      "validator": _vm.FORM_VALIDATORS.name,
      "max-length": _vm.textNameFieldMaxLength
    },
    on: {
      "input": function($event) {
        _vm.formForecast.name = $event;
        _vm.onInputChange();
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('section', {
    staticClass: "middle"
  }, [(_vm.brandWithCampaigns) ? _c('div', [(_vm.ForecastValidator.canUpdateCampaign(_vm.forecast)) ? _c('div', [_c('h3', [_vm._v("Launch Campaigns *")]), _vm._v(" "), _c('div', {
    staticClass: "campaigns"
  }, [_c('div', {
    staticClass: "campaigns-inner"
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('div', {
      key: campaign.id
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": 'camp-' + campaign.id,
        "name": "campaigns"
      },
      domProps: {
        "checked": _vm.formForecast.campaign && campaign.id === _vm.formForecast.campaign.id,
        "value": campaign.id
      },
      on: {
        "change": function($event) {
          _vm.addCampaignById(campaign.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'camp-' + campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name))])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "launch-date"
  }, [_vm._v("\n                            Campaign:\n                            "), (_vm.formForecast.campaign) ? _c('span', [_vm._v(_vm._s(_vm.formForecast.campaign.refClient) + " • " + _vm._s(_vm.formForecast.campaign.name))]) : _vm._e(), _c('br'), _vm._v("\n                            Launch Date :\n                            "), (_vm.formForecast.campaign) ? [_vm._v(_vm._s(_vm.formatDate(_vm.formForecast.campaign.launchDate)))] : _vm._e(), _c('br'), _vm._v("\n                            Availability Date :\n                            "), (_vm.formForecast.campaign) ? [_vm._v(_vm._s(_vm.formatDate(_vm.formForecast.campaign.availabilityDate)))] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.formForecast.campaign && _vm.formForecast.campaign.preseriesDate != null) ? [_vm._v("\n                                Preseries Date : " + _vm._s(_vm.formatDate(_vm.parseDate(_vm.formForecast.campaign.preseriesDate))) + " "), _c('br')] : _vm._e(), _vm._v("\n                            End of Campaign :\n                            "), (_vm.formForecast.campaign) ? [_vm._v(_vm._s(_vm.formatDate(_vm.formForecast.campaign.endDate)))] : _vm._e()], 2)])]) : _c('div', [_c('h3', [_vm._v("Launch Campaigns")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.forecast.campaign.name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "forecastWindowDates",
    class: {
      solo: !_vm.brandWithCampaigns
    }
  }, [_c('h3', [_vm._v("Forecast Window Dates:")]), _vm._v(" "), _c('section', [_c('Datepicker', {
    attrs: {
      "label": 'Start Date *',
      "value": _vm.formForecast.startDate,
      "max": _vm.formatDate(_vm.formForecast.endDate, 'YYYY-MM-DD'),
      "labelWidth": 170
    },
    on: {
      "input": function($event) {
        _vm.formForecast.startDate = $event;
        _vm.onInputChange();
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('Datepicker', {
    attrs: {
      "label": 'End Date *',
      "value": _vm.formForecast.endDate,
      "min": _vm.formatDate(_vm.formForecast.startDate, 'YYYY-MM-DD'),
      "labelWidth": 170
    },
    on: {
      "input": function($event) {
        _vm.formForecast.endDate = $event;
        _vm.onInputChange();
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('Datepicker', {
    attrs: {
      "label": 'Launch Date *',
      "value": _vm.formForecast.launchDate,
      "labelWidth": 170,
      "disabled": _vm.isForecastPublished
    },
    on: {
      "input": function($event) {
        _vm.formForecast.launchDate = $event;
        _vm.onInputChange();
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('Datepicker', {
    attrs: {
      "label": 'Availability Date *',
      "value": _vm.formForecast.availabilityDate,
      "labelWidth": 170,
      "disabled": _vm.isForecastPublished
    },
    on: {
      "input": function($event) {
        _vm.setAvailabilityDate($event);
        _vm.onInputChange();
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('Datepicker', {
    attrs: {
      "label": 'Preseries Date',
      "value": _vm.formForecast.preseriesDate,
      "labelWidth": 170,
      "disabled": _vm.isForecastApproved
    },
    on: {
      "input": function($event) {
        _vm.formForecast.preseriesDate = $event;
        _vm.onInputChange();
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('Datepicker', {
    attrs: {
      "label": 'End of Campaign',
      "value": _vm.formForecast.endOfCampaign,
      "labelWidth": 170,
      "disabled": _vm.isForecastPublished
    },
    on: {
      "input": function($event) {
        _vm.formForecast.endOfCampaign = $event;
        _vm.onInputChange();
      }
    }
  })], 1), _vm._v(" "), _c('section', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h3', [_vm._v("Recurrences:")]), _vm._v(" "), _c('SelectBloc', {
    attrs: {
      "value": _vm.formForecast.recurrenceAmount,
      "required": true,
      "options": _vm.numberOfRecursionOptions,
      "label": 'Recurrence',
      "append-text": 'months',
      "labelWidth": 168
    },
    on: {
      "change": function($event) {
        _vm.formForecast.recurrenceAmount = $event === '' ? null : parseInt($event);
        _vm.onInputChange();
      }
    }
  }, [_c('template', {
    slot: "noneValue"
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Please choose")])])], 2), _vm._v(" "), _c('Datepicker', {
    attrs: {
      "label": 'Reference Date *',
      "disabled": this.refDateIsEqualToAvailabilityDate || _vm.isForecastPublished,
      "value": _vm.formForecast.refDate,
      "labelWidth": 170
    },
    on: {
      "input": function($event) {
        _vm.formForecast.refDate = $event;
        _vm.onInputChange();
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('section', [_c('label', {
    staticClass: "uppercase",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _c('textarea', {
    attrs: {
      "id": "message",
      "maxlength": "5000"
    },
    domProps: {
      "value": _vm.formForecast.comments
    },
    on: {
      "input": function($event) {
        _vm.formForecast.comments = $event.target.value;
        _vm.onInputChange();
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('section', {
    staticClass: "zone-selection"
  }, [_c('ZoneSelection', {
    attrs: {
      "selected-zones": _vm.formForecast.zones,
      "forecast": _vm.forecast,
      "disabled": !_vm.ForecastValidator.canUpdate(_vm.forecast)
    },
    on: {
      "update": _vm.updateZones
    }
  }), _vm._v(" "), _c('br'), _c('br')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a2cede6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/ForecastForm.vue
// module id = 3003
// module chunks = 0